var map = {
	"./case.svg": "2085",
	"./flag.svg": "a0cc",
	"./people.svg": "5958",
	"./person.svg": "b79a",
	"./star.svg": "7927",
	"./visa-disabled.svg": "c7e0",
	"./visa.svg": "b7db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44b6";